module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_6_5.6fd5d097.png";